import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ currentUser, isSupervisor }) => {
  const location = useLocation();

  // Navigation items
  const navigationItems = [
    ...(isSupervisor ? [{
      path: '/supervisor',
      icon: '🏢',
      label: 'Supervisor',
      description: 'Practice-wide analytics'
    }] : []),
    {
      path: '/',
      icon: '📊',
      label: 'Dashboard',
      description: 'Overview and stats'
    },
    {
      path: '/record',
      icon: '🎤',
      label: 'AI Scribe',
      description: 'Speak your documentation'
    },
    {
      path: '/templates',
      icon: '📝',
      label: 'Templates',
      description: 'Manage note formats'
    },
    {
      path: '/analytics',
      icon: '📈',
      label: 'Visual Analytics',
      description: 'Charts and insights'
    },
    {
      path: '/subscription/plans',
      icon: '💳',
      label: 'Subscription',
      description: 'Manage your plan'
    }
  ];

  const isActiveRoute = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const sidebarClasses = `
    w-80
    bg-white border-r border-gray-300 shadow-xl
    flex flex-col
    relative
  `.trim();

  return (
    <div className={sidebarClasses}>
      {/* Header */}
      <div className="p-3 border-b border-gray-200">
        <img 
          src="/chartara_labs_logo.png" 
          alt="Chartara Labs" 
          className="w-40 h-20 object-contain mx-auto"
        />
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-6">
        <ul className="space-y-3">
          {navigationItems.map((item) => {
            const isActive = isActiveRoute(item.path);
            
            const linkClasses = `
              flex items-center gap-4 p-4 rounded-xl
              transition-all duration-200 ease-in-out
              ${isActive 
                ? 'bg-blue-50 border-l-4 border-blue-600 text-blue-700 shadow-md' 
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900 hover:shadow-sm'
              }
            `.trim();

            return (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={linkClasses}
                >
                  <span className="text-2xl flex-shrink-0">
                    {item.icon}
                  </span>
                  
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-lg">
                      {item.label}
                    </div>
                    <div className="text-sm text-gray-500 truncate">
                      {item.description}
                    </div>
                  </div>
                  
                  {isActive && (
                    <div className="w-3 h-3 bg-blue-600 rounded-full flex-shrink-0"></div>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

    </div>
  );
};

export default Sidebar;